import { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';

import moment from 'moment';
import PropTypes from 'prop-types';

import * as types from '../constants';
import CustomIcon from '../CustomIcons';
import TruckIcon from '../page/assets/TruckIcon';
import { getAppConfig } from '../utilities';

import './styles/index.css';

const NotificationItem = ({ ...props }) => {
  const { notificationTileInfo, handleClose, apiData, handleRead } = props;
  const { lang } = getAppConfig('locale');

  useEffect(() => {
    moment.locale(lang);
  }, []);

  const getIcon = () => ({
    [types.CONTRACT_NOTIFICATION]: <CustomIcon type="document" size="32" className="contracts-icon" />,
    [types.ORDER_NOTIFICATION]: <TruckIcon height="32" width="32" fill="#658d1b" />,
    [types.ORDER_NOTIFICATION_ADDITIONAL]: <TruckIcon height="32" width="32" fill="#658d1b" />,
    [types.UPDATED_TECH_DOC_NOTIFICATION]: <CustomIcon type="documentSearch" size="32" />,
    [types.REMOVED_TECH_DOC_NOTIFICATION]: <CustomIcon type="documentSearch" size="32" />,
    [types.UPDATED_PROD_DOC_NOTIFICATION]: <CustomIcon type="assignmentTurnedIn" size="32" />,
    [types.REMOVED_PROD_DOC_NOTIFICATION]: <CustomIcon type="assignmentTurnedIn" size="32" />,
    default: <CustomIcon type="settings" />
  });

  const getDateTime = (createdTime, notificationType) => {
    const translations = getAppConfig(types.INLINE_TRANSLATIONS);
    const commonLocaleStr = 'ddd M/D';
    const currentDateTimeInstance = moment();
    const givenDateTimeInstance = moment(createdTime);
    const isThisWeek = currentDateTimeInstance.isoWeek() === givenDateTimeInstance.isoWeek();
    const dateTimeFormat = isThisWeek ? commonLocaleStr : translations[lang].localeDateStr;
    if (
      notificationType.toLowerCase() === types.CONTRACT_NOTIFICATION ||
      notificationType.toLowerCase() === types.ORDER_NOTIFICATION ||
      notificationType.toLowerCase() === types.ORDER_NOTIFICATION_ADDITIONAL ||
      notificationType.toLowerCase() === types.REMOVED_TECH_DOC_NOTIFICATION ||
      notificationType.toLowerCase() === types.UPDATED_TECH_DOC_NOTIFICATION ||
      notificationType.toLowerCase() === types.REMOVED_PROD_DOC_NOTIFICATION ||
      notificationType.toLowerCase() === types.UPDATED_PROD_DOC_NOTIFICATION
    ) {
      if (isThisWeek) {
        return moment(createdTime).format(dateTimeFormat);
      }
      return moment(createdTime).format(dateTimeFormat);
    }
    return moment(createdTime).format('MM-DD-YYYY, hh:mm:ss a');
  };

  const getMessageWithNavigation = () => {
    const relativePath = apiData.messageData.find(item => item.key === types.PAGE_RELATIVE_PATH);
    let orderId = '';
    if (
      notificationTileInfo.apiKey &&
      (notificationTileInfo.apiKey.toLowerCase() === types.ORDER_NOTIFICATION ||
        notificationTileInfo.apiKey.toLowerCase() === types.ORDER_NOTIFICATION_ADDITIONAL)
    ) {
      const orderDetails = apiData.messageData.find(item => item.key === 'orderId');
      orderId = orderDetails && orderDetails.value;
    }
    const descriptionTwo = notificationTileInfo.descTwo.includes('##')
      ? notificationTileInfo.descTwo.replace('##', `${orderId}`)
      : notificationTileInfo.descTwo;

    let navigationLink = notificationTileInfo.link;
    if (
      notificationTileInfo.apiKey &&
      (notificationTileInfo.apiKey.toLowerCase() === types.REMOVED_TECH_DOC_NOTIFICATION ||
        notificationTileInfo.apiKey.toLowerCase() === types.UPDATED_TECH_DOC_NOTIFICATION ||
        notificationTileInfo.apiKey.toLowerCase() === types.UPDATED_PROD_DOC_NOTIFICATION ||
        notificationTileInfo.apiKey.toLowerCase() === types.REMOVED_PROD_DOC_NOTIFICATION)
    ) {
      const details = apiData.messageData.find(item => item.key === 'documentName');
      navigationLink = notificationTileInfo.link.replace('##', `${details.value}`);
    }
    return (
      <>
        {`${notificationTileInfo.descOne} `}
        <span
          onClick={e => handleRead(e, apiData, relativePath)}
          onKeyDown={e => handleRead(e, apiData, relativePath)}
          tabIndex={0}
          role="button"
        >
          {ReactHtmlParser(navigationLink)}
        </span>
        {` ${descriptionTwo}`}
      </>
    );
  };

  const getHeading = () => notificationTileInfo.heading;

  return (
    <div className={`body-content ${apiData.read ? 'read' : 'un-read'}`}>
      <div className="icon">{getIcon()[apiData.messageTitle.toLowerCase()]}</div>
      <div className="body-info">
        <div className="meta-details-wrapper">
          <div className="meta-content">
            <div className="notification-type">{notificationTileInfo.value}</div>
            <div className="dot-seperator" />
            <div className="notification-time">{getDateTime(apiData.creationDate, apiData.messageTitle)}</div>
          </div>
        </div>
        <div className="heading">{getHeading()}</div>
        <div className="message">{getMessageWithNavigation()}</div>
      </div>
      <div
        className="remove-notification"
        onClick={e => handleClose(e, apiData)}
        role="button"
        onKeyDown={e => handleClose(e, apiData)}
        tabIndex={-1}
        aria-label="remove"
      >
        <CustomIcon type="mdClose" size="24" className="close-icon" fill="#666666" />
      </div>
    </div>
  );
};

NotificationItem.propTypes = {
  apiData: PropTypes.instanceOf(Object),
  notificationTileInfo: PropTypes.instanceOf(Object),
  handleClose: PropTypes.func,
  handleRead: PropTypes.func
};

NotificationItem.defaultProps = {
  apiData: PropTypes.shape({
    read: 0,
    messageTitle: '',
    notificationId: '',
    creationDate: '',
    messageLabel: '',
    messageData: PropTypes.shape([
      {
        key: '',
        value: ''
      }
    ])
  }),
  notificationTileInfo: PropTypes.shape({
    value: '',
    heading: '',
    contractsMessage: '',
    apiKey: ''
  }),
  handleClose: () => {},
  handleRead: () => {}
};

export default NotificationItem;
